import { assertResolvedAtsNotHttpError } from '@/api/ats/atsEnvelope';
import { useQuery } from '@tanstack/react-query';
import { http } from '@/lib/ats-https';

export interface Office {
  id: number;
  name: string;
  hq: boolean;
  remote: boolean;
  email: string | null;
  phone_number: string | null;
  ats_location_id: number | null;
  place_id: string | null;
  location: string | null;
  places_country_id: number | null;
  places_state_id: number | null;
  places_city_id: number | null;
  country_name: string | null;
  state_name: string | null;
  city_name: string | null;
  latitude: number | string;
  longitude: number | string;
}

interface GetOfficesApiResponse {
  data: Office[];
  errors: string[];
}

export const useGetOffices = () => {
  const query = useQuery<GetOfficesApiResponse, Error>({
    queryKey: ['get-offices'],
    queryFn: async () => {
      const res = await http.get<GetOfficesApiResponse>('ats_offices');
      assertResolvedAtsNotHttpError(res);
      return res as unknown as GetOfficesApiResponse;
    },
    staleTime: 3 * 60 * 1000, // 3 minutes
  });

  const offices = query?.data?.data ?? [];
  const uiError = query?.data?.errors ?? [];

  return { offices, uiError, ...query };
};
